import { Component, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { DxFileUploaderComponent } from 'devextreme-angular';
import { APP_CONFIG } from '../../../../../src/app/config/app-config.module';
import { AppConfig } from '../../../../../src/app/core/config-models/app-config.model';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import {
  IApproveDocsRequest,
  IRejectDocsRequest,
  RejectReason
} from '../../../features/employee-detail/models/approve-document.model';
import { fromApproveActions, fromHomeAddressActions, fromProfileStatusActions } from '../../../features/employee-detail/actions';
import { loadDownloadFile } from '../../../static-data/actions';
import { IDownloadFileRequest } from '../../../static-data/models/download-file.model';
import { fromSelectedBusinessSelector } from '../../../features/businesses/selectors';
import { IRejectionReason } from '../../../../../src/app/static-data/models/rejection-reason.model';
import { fromStaticDataRejectionReasonSelector } from '../../../static-data/selectors';
import * as fromStaticDataActions from '../../../static-data/actions';
import { IStaticDataResponse } from '../../../static-data/models/static-data.model';
import { getStaticDataProofOfAddressDocumentTypesResponse } from '../../../static-data/selectors/proof-of-address-document-types.selectors';
import {
  hasNonBlankEmployeeRejectionMessage,
  hasRejectionReasonSelection
} from 'src/app/shared/utils/document-rejection-form.util';

@Component({
  selector: 'app-address-proof-validation',
  templateUrl: './address-proof-validation.component.html',
  styleUrls: ['./address-proof-validation.component.css']
})
export class AddressProofValidationComponent implements OnInit, OnDestroy {
  @ViewChild('replaceFileUploader', { static: false }) replaceFileUploader: DxFileUploaderComponent;

  @Input() currentImageData: any;
  @Input() imagesForPrevious: any;
  @Input() showFicaBtn: boolean = false;
  @Input() showUploadBtn: boolean = false;

  videoFile: any;
  video: boolean;

  imageClicked: boolean;
  getCurrentPicObs$: Observable<any>;
  openPic: boolean;
  extraInfo: string;

  getUploadedFileStatus$: Observable<boolean>;
  displayRejectModal: boolean;
  fileID: string;
  fileType: string;
  fileTypeId: string;
  reason: string;
  privateNotes: string;
  option: IRejectionReason;
  rejectionReason$: Observable<IRejectionReason[]>;
  subscription: Subscription = new Subscription();
  chosen: string;
  businessId: string;
  displayUploadModal: boolean;
  selectedTabIndex: number = 0;
  tabsWithText: any[];
  headers: any;
  allRejectionReasons: any[];
  selectedRejectReason: any;
  rejectionSubmitAttempted = false;
  proofOfAddressDocumentTypes$: Observable<IStaticDataResponse[]>;
  proofOfAddressDocumentTypes: IStaticDataResponse[] = [];
  selectedDocumentTypeId: string = '';
  selectedDocumentType: IStaticDataResponse | null = null;

  displayReplaceModal: boolean = false;
  /** Popup copy: Upload (no document yet) vs Replace (existing document). */
  addressProofModalMode: 'upload' | 'replace' = 'replace';
  currentFileToReplace: any = null;
  fileNameFICA: string = '';
  uploadFICAURL: string = '';
  replaceFileSelected: boolean = false;

  get isAddressProofUploadModal(): boolean {
    return this.addressProofModalMode === 'upload';
  }

  get addressProofPopupTitle(): string {
    return this.isAddressProofUploadModal ? 'Proof of Address Document' : 'Proof of Address Document';
  }

  get addressProofDocumentTypeHint(): string {
    return this.isAddressProofUploadModal
      ? '* Document type must be selected before uploading the file'
      : '* Document type must be selected before replacing the file';
  }

  get addressProofFileFieldLabel(): string {
    return this.isAddressProofUploadModal ? 'Select file to upload *' : 'Select replacement file *';
  }

  get addressProofPrimaryButtonText(): string {
    return this.isAddressProofUploadModal ? 'Upload' : 'Replace';
  }

  get addressProofCurrentFileSectionTitle(): string {
    return this.isAddressProofUploadModal ? 'Current record' : 'Current file';
  }

  constructor(
    private store: Store,
    private helperService: HelpersService,
    private analytics: AngularFireAnalytics,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.rejectionReason$ = this.store.select(fromStaticDataRejectionReasonSelector.getStaticDataRejectionResponse);
    this.rejectionReason$.subscribe(response => {
      this.allRejectionReasons = response;
    });
    this.tabsWithText = [{ id: 1, text: 'Current' }, { id: 2, text: 'Archived' }];

    this.proofOfAddressDocumentTypes$ = this.store.select(getStaticDataProofOfAddressDocumentTypesResponse);
    this.proofOfAddressDocumentTypes$.subscribe((types: IStaticDataResponse[]) => {
      this.proofOfAddressDocumentTypes = types || [];
    });
  }

  ngOnInit() {
    this.displayRejectModal = false;
    this.displayUploadModal = false;

    this.subscription.add(
      this.store.select(fromSelectedBusinessSelector.getSelectedBusinesses).subscribe(data => {
        if (data != undefined) {
          this.businessId = data.id;
        }
      })
    );

    const bearerToken = sessionStorage.getItem('token');
    this.headers = { Authorization: `Bearer ${bearerToken || ''}` };

    this.store.dispatch(fromStaticDataActions.fromProofOfAddressDocumentTypesAction.loadProofOfAddressDocumentTypes());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSelectionChanged(e) {
    const index = e.addedItems[0].id - 1;
    this.selectedTabIndex = index;
  }

  openFileInBrowser(val) {
    this.analytics.logEvent('view document in browser');
    const ext = val?.fileName?.match(/\.([a-zA-Z0-9]+)(?:\?|$)/)?.[1];
    const req: IDownloadFileRequest = {
      documentName: val.fileName,
      ...(ext && { imageType: ext })
    };
    this.store.dispatch(loadDownloadFile({ request: req }));
  }

  openFileInBrowser2(extension: string, newBase64Str: string) {
    let win;

    switch (true) {
      case extension === 'jpeg' ||
        extension === 'JPG' ||
        extension === 'png' ||
        extension === 'PNG' ||
        extension === 'txt' ||
        extension === 'JPEG' ||
        extension === 'jpg' ||
        extension === 'TXT' ||
        extension === 'tiff' ||
        extension === 'TIFF':
        win = window.open();

        const data = `data:image/${extension};base64,${newBase64Str}`;

        win.document.write(
          '<iframe src="' +
            data +
            '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
        );
        break;
      case extension === 'rtf':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/rtf;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'xml':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/xml;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'pdf' || extension === 'PDF':
        win = window.open();
        win.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(newBase64Str) + "'></iframe>"
        );
        break;
      case extension === 'mp4' ||
        extension === 'm4v' ||
        extension === '3gp' ||
        extension === 'avi' ||
        extension === 'flv' ||
        extension === 'mkv' ||
        extension === 'mov' ||
        extension === 'mpeg' ||
        extension === 'mpg' ||
        extension === 'mts' ||
        extension === 'vob' ||
        extension === 'webm' ||
        extension === 'wmv':
        this.videoFile = `data:${extension};base64,${newBase64Str}`;
        this.video = true;
        break;
      default:
        break;
    }
  }

  get showRejectionReasonError(): boolean {
    return (
      this.rejectionSubmitAttempted &&
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option)
    );
  }

  get showEmployeeMessageError(): boolean {
    return this.rejectionSubmitAttempted && !hasNonBlankEmployeeRejectionMessage(this.reason);
  }

  saveRejectionReason() {
    this.rejectionSubmitAttempted = true;
    if (
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option) ||
      !hasNonBlankEmployeeRejectionMessage(this.reason)
    ) {
      return;
    }
    this.rejectionSubmitAttempted = false;

    const rejectReason: RejectReason = {
      customerId: this.helperService.checkCustomerIdState(),
      adminPrivateNotes: this.privateNotes,
      extraInfo: this.reason,
      uploadedFileId: this.fileID,
      uploadedFileRejectReasonId: this.selectedRejectReason.id
    };

    const req: IRejectDocsRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      uploadedFileId: this.fileID,
      uploadedFileType: this.fileTypeId,
      rejectReason: rejectReason
    };

    this.store.dispatch(
      fromApproveActions.rejectDocumentRequest({
        request: req
      })
    );
    this.displayRejectModal = false;
    this.selectedRejectReason = null;
  }

  declineDocument(uploadedFileId, uploadedFileTypeDescription, uploadedFileTypeId) {
    this.displayRejectModal = true;
    this.fileID = uploadedFileId;
    this.fileType = uploadedFileTypeDescription;
    this.fileTypeId = uploadedFileTypeId;

    this.privateNotes = '';
    this.reason = '';
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
    this.option = {
      id: '',
      description: '',
      extraInfo: ''
    };
  }

  close() {
    this.imageClicked = false;
    this.video = false;
  }

  imageApproveFunction(uploadedFileId, userIdentityId, uploadedFileTypeDescription, uploadedFileTypeId) {
    const req: IApproveDocsRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      userIdentityId: userIdentityId,
      uploadedFileId: uploadedFileId,
      uploadedFileType: uploadedFileTypeId
    };

    this.store.dispatch(
      fromApproveActions.approveDocumentRequest({
        request: req
      })
    );
  }

  onImageStatus(val) {}

  onChangeTab($event) {}

  selected(e) {
    this.selectedRejectReason = this.allRejectionReasons.find(item => item.id === e.value);
    this.reason = this.selectedRejectReason?.extraInfo ?? '';
  }

  uploadDoc() {
    this.displayUploadModal = false;
  }

  delete() {}

  /** Clears selected files and DevExtreme file uploader UI (value + reset). */
  private clearReplaceFileUploader(): void {
    this.replaceFileSelected = false;
    const inst = this.replaceFileUploader?.instance;
    if (!inst) {
      return;
    }
    inst.option('value', []);
    inst.reset();
  }

  replaceFICADocument(file) {
    this.currentFileToReplace = file;
    this.selectedDocumentTypeId = '';
    this.selectedDocumentType = null;
    this.fileNameFICA = '';
    this.uploadFICAURL = '';
    this.replaceFileSelected = false;
    this.displayReplaceModal = true;
    setTimeout(() => this.clearReplaceFileUploader(), 0);
  }

  onDocumentTypeChanged(e: any) {
    this.selectedDocumentTypeId = e.value;
    this.selectedDocumentType = this.proofOfAddressDocumentTypes.find(docType => docType.id === e.value) || null;
    if (this.selectedDocumentTypeId && this.currentFileToReplace) {
      this.prepareAddressProofReplaceUpload();
    } else {
      this.uploadFICAURL = '';
      this.fileNameFICA = '';
    }
  }

  onReplaceFileValueChanged(e: { value?: File[] }) {
    const files = e?.value;
    this.replaceFileSelected = Array.isArray(files) && files.length > 0;
  }

  executeReplaceUpload() {
    this.prepareAddressProofReplaceUpload();
    if (!this.selectedDocumentTypeId || !this.currentFileToReplace?.uploadedFileId) {
      this.helperService.notifyWarning(
        this.isAddressProofUploadModal
          ? 'Select a document type before uploading.'
          : 'Select a document type before replacing.',
        400,
        3000
      );
      return;
    }
    if (!this.uploadFICAURL) {
      this.helperService.notifyWarning('Could not prepare upload. Try selecting the document type again.', 400, 3000);
      return;
    }
    const uploader = this.replaceFileUploader?.instance;
    if (!uploader) {
      return;
    }
    const pending = uploader.option('value') as File[] | undefined;
    if (!pending || pending.length === 0) {
      this.helperService.notifyWarning(
        this.isAddressProofUploadModal ? 'Choose a file to upload first.' : 'Choose a replacement file first.',
        400,
        3000
      );
      return;
    }
    uploader.upload();
  }

  prepareAddressProofReplaceUpload() {
    if (!this.currentFileToReplace || !this.selectedDocumentTypeId) {
      return;
    }
    const uploadedFileId = this.currentFileToReplace.uploadedFileId;
    if (!uploadedFileId) {
      return;
    }
    const customerId = this.helperService.checkCustomerIdState();
    this.fileNameFICA = `Address/${uploadedFileId}`;
    this.uploadFICAURL = `${this.appConfig.apiEndpoint}/CustomerAdmin/${customerId}/HomeAddress/UploadedFile/${uploadedFileId}/Replace/${this.selectedDocumentTypeId}`;
  }

  customProofOfAddressDocumentTypeHandler(e: any) {
    const selected = this.proofOfAddressDocumentTypes.find(p => p.description === e.text);
    if (selected) {
      e.customItem = selected;
    }
  }

  openReplacePopup(file: any, mode: 'upload' | 'replace' = 'replace') {
    this.addressProofModalMode = mode;
    this.replaceFICADocument(file);
  }

  closeReplacePopup() {
    this.displayReplaceModal = false;
    this.addressProofModalMode = 'replace';
    this.currentFileToReplace = null;
    this.selectedDocumentTypeId = '';
    this.selectedDocumentType = null;
    this.fileNameFICA = '';
    this.uploadFICAURL = '';
    this.clearReplaceFileUploader();
  }

  onReplaceUploadSuccess() {
    const wasUploadModal = this.isAddressProofUploadModal;
    this.helperService.notifySuccess(
      wasUploadModal ? 'Uploaded successfully.' : 'Replaced successfully.',
      300,
      3000
    );
    this.store.dispatch(
      fromHomeAddressActions.loadHomeAddresss({
        request: this.helperService.checkCustomerIdState()
      })
    );
    this.store.dispatch(
      fromProfileStatusActions.loadProfileStatus({
        request: {
          customerId: this.helperService.checkCustomerIdState()
        }
      })
    );
    this.clearReplaceFileUploader();
    setTimeout(() => {
      this.clearReplaceFileUploader();
      this.closeReplacePopup();
    }, 0);
  }

  errorUploadedAddressProof(fileUploader: DxFileUploaderComponent, error: any) {
    this.helperService.handleGeneralErrors(false, 'Oops', `${error.error?.status} - ${error.error?.statusText}`);
    fileUploader?.instance?.reset();
  }

  closeRejectionPop() {
    this.displayRejectModal = false;
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
  }
}
